var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_2407_1474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.05 30.12C56.01 19.77 46.92 12 36 12C27.33 12 19.8 16.92 16.05 24.12C7.02 25.08 0 32.73 0 42C0 51.93 8.07 60 18 60H57C65.28 60 72 53.28 72 45C72 37.08 65.85 30.66 58.05 30.12ZM57 54H18C11.37 54 6 48.63 6 42C6 35.85 10.59 30.72 16.68 30.09L19.89 29.76L21.39 26.91C24.24 21.42 29.82 18 36 18C43.86 18 50.64 23.58 52.17 31.29L53.07 35.79L57.66 36.12C62.34 36.42 66 40.35 66 45C66 49.95 61.95 54 57 54ZM24 39H31.65V48H40.35V39H48L36 27L24 39Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2407_1474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.a46313ed3493dbb33198fc988edc2928.svg";
export { ForwardRef as ReactComponent };